module.exports = __webpack_public_path__ + "static/media/logo-stone.3d41b361.svg";